export const signout = () => {
  localStorage.clear();
  window.location.href = "/login";
};
